module.exports = __webpack_public_path__ + "img/ketop.19f523b9.png";